import axiosClient from "utils/axios";
import { ApiList, ApiOptionList, ApiResponse } from "../../../types/api.types";
import {
  CreateRolePayload,
  Role,
  UpdateRolePermission,
  UpdateRolePayload,
  RolePermission,
} from "features/RolesAndPermissions/types/role.types";

export const getRoles = async ({
  page,
  limit,
  offset,
  search,
}: {
  page?: number;
  limit?: number;
  offset?: number;
  search?: string;
} = {}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiList<Role[]>>>(
      "/roles",
      {
        params: {
          page,
          limit,
          offset,
          search,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching roles: ", err);
    throw err;
  }
};

export const getRoleOptions = async ({
  query,
  limit,
  page,
}: {
  query?: string;
  limit?: number;
  page?: number;
}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiOptionList>>(
      `/roles/options`,
      {
        params: {
          query,
          limit,
          page,
        },
      },
    );

    return response.data;
  } catch (err) {
    console.warn("Error fetching User Options : ", err);
    throw err;
  }
};

export const createRole = async (payload: CreateRolePayload) => {
  try {
    const response = await axiosClient.post<ApiResponse<Role>>(
      "/roles",
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error creating Role : ", err);
    throw err;
  }
};

export const getRolePermission = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.get<ApiResponse<RolePermission>>(
      `/roles/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Role : ", err);
    throw err;
  }
};

export const updateRole = async (id: number, payload: UpdateRolePayload) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.put<ApiResponse<Role>>(
      `/roles/${id}`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating Role : ", err);
    throw err;
  }
};

export const updateRolePermissions = async (
  id: number,
  payload: UpdateRolePermission,
) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const body: UpdateRolePermission = {
      ...payload,
      roleId: payload.roleId ?? id,
    };
    const response = await axiosClient.post<ApiResponse<Role>>(
      `/roles/${id}/set-permissions`,
      body,
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating role permissions : ", err);
    throw err;
  }
};

export const deleteRole = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.delete<ApiResponse<Role>>(
      `/roles/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error deleting Role : ", err);
    throw err;
  }
};
